import { iconColors as colors } from '../../colors';


const style = theme => ({
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  menuFilterContainer: {
    [theme.breakpoints.down('sm')]: {
      width: '70vw'
    },
    userSelect: 'none',
    maxWidth: '300px',
    height: "80%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  menuFilterFormControl: {
    flex: "1 1 calc(50% - 24px)",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  filterEnabled: {
    color: colors.attention,
  },
  table: {
    tableLayout: 'fixed',
    width: '100%',
    whiteSpace: 'nowrap',
    overflowY: 'auto',
    flexShrink: 0,
    userSelect: 'none',
  },
  table_cell_header: {
    fontWeight: 'bold',
    color: theme.palette.common.black,
  },
  table_cell: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: 0,
    textAlign: 'center',
  },
  button: {
    padding: 0,
  },
});

export default style;
